<template>
  <div :class="`error || ${type}`">
    <CustomIcon v-if="type === 'large' && icon" :name="`error/${icon}`" />
    <div v-if="type === 'small' && icon" class="warning-sign">
      <div class="warning-sign-image"></div>
    </div>
    <h4 v-if="title" class="error-title">{{ title }}</h4>
    <p v-if="description" class="error-description">{{ description }}</p>
    <CustomButton class="button" variation="primary" :onClick="callToAction">{{
      ctaText
    }}</CustomButton>
  </div>
</template>
<script>
import CustomButton from "./CustomButton.vue";
import CustomIcon from "./CustomIcon.vue";
export default {
  name: "error-component",
  props: {
    type: String,
    title: String,
    description: String,
    icon: String,
    ctaText: String,
    callToAction: Function,
  },
  components: { CustomButton, CustomIcon },
};
</script>
